// extracted by mini-css-extract-plugin
export default {"preview":"preview_preview__YFQwR","title":"preview_title__XCB0-","cards":"preview_cards__i3u-Z"};